import Navbar from '../../components/feature/Navbar';
import SeoHead from '../../components/feature/SeoHead';
import Hero from './components/Hero';
import Mission from './components/Mission';
import ProjectOverview from './components/ProjectOverview';
import Technology from './components/Technology';
import Impact from './components/Impact';
import CTA from './components/CTA';
import Footer from '../../components/feature/Footer';

const siteUrl = (import.meta.env.VITE_SITE_URL as string | undefined) ?? '';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: '株式会社C.GREEN',
      url: siteUrl,
      description:
        '廃校を活用した循環型陸上養殖プロジェクトで地域創生・地域雇用・持続可能な地域社会を実現する会社です。',
      foundingLocation: {
        '@type': 'Place',
        name: '日本',
      },
    },
    {
      '@type': 'WebSite',
      name: '株式会社C.GREEN',
      url: siteUrl,
      inLanguage: 'ja',
    },
  ],
};

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="株式会社C.GREEN | 廃校活用による地域創生プロジェクト | 循環型陸上養殖"
        description="株式会社C.GREENは廃校を活用した循環型陸上養殖プロジェクトを通じて、地域雇用の創出と持続可能な地域社会の実現に貢献します。筑波大学の先進技術と地域資源を活かし、環境に配慮した新しい産業拠点を創出します。"
        keywords="C.GREEN,シーグリーン,廃校活用,地域創生,陸上養殖,循環型養殖,筑波大学,地域雇用,サステナビリティ,環境技術,地域活性化"
        canonicalPath="/"
        jsonLd={homeJsonLd}
      />
      <Navbar />
      <Hero />
      <Mission />
      <ProjectOverview />
      <Technology />
      <Impact />
      <CTA />
      <Footer />
    </div>
  );
}